// src/pages/History/MedievalHistory/IslamicCaliphatesGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Middle_Ages_-_Islamic_Caliphates.png';

function HistoryPageCaliphatesGo() {
  return (
    <QuizPage
      title="History: Islamic Caliphates"
      subTopic="Islamic Caliphates"
      backgroundImage={historyImage}
      returnPath="/History-Islamic-Caliphates"
    />
  );
}

export default HistoryPageCaliphatesGo;   